import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatAnchor } from '@angular/material/button';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LoginService } from '@app/services';
import { AuthService, User } from '@auth0/auth0-angular';
import { InjectionTokens } from '@src/serviceTokens';
import { Observable } from 'rxjs';

@Component({
  selector: 'lausd-navigation-menu',
  standalone: true,
  templateUrl: './navigation-menu.component.html',
  styleUrls: ['./navigation-menu.component.scss'],
  imports: [MatAnchor, RouterLink, RouterLinkActive, AsyncPipe],
})
export class NavigationMenuComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  protected loginService: LoginService = inject(InjectionTokens.get(LoginService));

  currentUser$: Observable<User | null | undefined>;

  constructor(private auth: AuthService) {}

  ngOnInit() {
    this.currentUser$ = this.auth.user$.pipe(takeUntilDestroyed(this.destroyRef));
  }

  get isAuthenticated(): boolean {
    return !!this.loginService.user;
  }

  get isVendor(): boolean {
    return this.loginService.isVendor;
  }

  get isAgency(): boolean {
    return this.loginService.isAgency;
  }

  get isColbi(): boolean {
    return this.loginService.isColbi;
  }

  hasPermission(permission: string): Observable<boolean> {
    return this.loginService.hasPermission(permission);
  }
}
